import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, CardContent, Dialog, Grid, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { CountdownCmp } from "../countdown/Countdown";
import { NoticeCountdownCmp } from "../countdown/NoticeCountdown";
import { title } from "process";
import { Formik } from "formik";
import { useMutation } from "react-query";
import { AddSupplierUsers, GetSupplierUsers } from "../../services/report.service";
import { AddSupplierUsersResponse, getSupplierUsersResponse } from "../../models/report.model";
import { object, string } from "yup";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import AutoCompleteSearch from "../dropdown/AutoCompleteSearch";
import SideSwich from "../switch/SideSwich";
import { GetCitiesResponse } from "../../models/basicInformation.model";
import { GetCities } from "../../services/basicInformation.service";
import { v4 as uuidv4 } from 'uuid';

const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function ModalAddSupplierUsers({
    openModel,
    setSendConfirmation,
    setOpenVerifyModal,
    setSendNotification,
}: any) {

    const id = window.localStorage.getItem("SUPPLIER_ID");
    const [open, setOpen] = React.useState<boolean>(openModel);
    const [city, setCity] = React.useState<any>();
    const [cityIds, setCityIds] = React.useState<number>(0);
    const [cities, setCities] = React.useState<GetCitiesResponse[]>([]);
    const [supplierNewUser, setSupplierNewUser] = React.useState<
        AddSupplierUsersResponse
    >();
    const [supplierUsers, setSupplierUsers] = React.useState<
        getSupplierUsersResponse[]
    >([]);
    const [showAddUserForm, setshowAddUserForm] = React.useState(true);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setOpenVerifyModal(false);
    };
    React.useEffect(() => {
        getCitiesMutate({});
        setOpen(openModel);
    }, [openModel]);

    function changeCityIds(e: any, value: any) {
        setCityIds(e);
        setCity(value);
    }
    const { mutate: getCitiesMutate } = useMutation(GetCities, {
        onSuccess: (data: GetCitiesResponse[]) => {
            if (data) {
                setCities(data);
            }
        },
        onError: () => { },
    });

    const { isLoading, mutate: GetSupplierUsersMutate } = useMutation(
        GetSupplierUsers,
        {
            onSuccess: (data: getSupplierUsersResponse[]) => {
                if (data) {
                    setSupplierUsers(data);
                }
            },
            onError: () => { },
        }
    );


    const { mutate: AddSupplierUsersMutate } = useMutation(AddSupplierUsers, {
        onSuccess: (data: AddSupplierUsersResponse) => {
            if (data) {
                setSupplierNewUser(data);
                GetSupplierUsersMutate({
                    supplierId: Number(id!),
                });
                setshowAddUserForm(false);
                setSendConfirmation(uuidv4());
                setOpen(false);
                setOpenVerifyModal(false);
            }
        },
        onError: () => { },
    });

    const usersValidation = object().shape({
        userFirstname: string()
            .ensure()
            .required("لطفا نام را وارد نمایید.")
            .matches(/^(?!\s+$).*/, "لطفا نام را صحیح وارد نمایید")
            .max(250, "نام نباید بیشتر از ۲۵۰ باشد"),
        userLastname: string()
            .ensure()
            .matches(/^(?!\s+$).*/, "لطفا نام خانوادگی را صحیح وارد نمایید")
            .required("لطفا نام خانوادگی را وارد نمایید.")
            .max(250, "نام خانوادگی نباید بیشتر از ۲۵۰ باشد"),

        mobileNo: string()
            .ensure()
            .required("لطفا شماره موبایل را وارد نمایید.")
            .matches(
                /^(\+98|0098|98|0)?9\d{9}$/,
                "لطفا شماره موبایل را صحیح وارد نمایید"
            ),
        // nationalCode: string().ensure(),
        // .required("لطفا کد ملی را وارد نمایید")
    });

    let initialValues: any = {
        userFirstname: "",
        userLastname: "",
        mobileNo: "",
        city: "",
        nationalCode: null,
    };
    const handleAddUser = (values: any) => {
        if (!values.isActive) {
            values.isActive = false;
        }
        values.cityTitle = city;
        values.city = cityIds;

        AddSupplierUsersMutate({
            firstName: values.userFirstname.trim(),
            lastName: values.userLastname.trim(),
            mobileNumber: values.mobileNo,
            // nationalCode: values.nationalCode,
            cityId: values.city,
            isSuperUser: values.isActive,
            supplierId: Number(id!),
        });
    };
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >
                <>
                    <Grid>
                        <Box
                            sx={style}
                            style={{ borderRadius: "6px", padding: "50px 40px 40px 40px" }}
                            className="ModalCmp  "
                        >

                            <Formik
                                initialValues={initialValues}
                                onSubmit={handleAddUser}
                                validateOnMount={true}
                                validationSchema={usersValidation}
                            >
                                {({
                                    handleSubmit,
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                }) => (
                                    <form
                                        onSubmit={handleSubmit}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                            }
                                        }}
                                    >
                                        <Grid
                                            container
                                            // columns={14}
                                            // gap={1}
                                            xs={12}
                                        // justifyContent={{
                                        //     xs: "center",
                                        //     sm: "center",
                                        //     md: "center",
                                        //     lg: "space-between",
                                        // }}
                                        // alignItems={"center"}
                                        // padding={"0 1rem"}
                                        // minHeight={"100px"}
                                        >
                                            <Grid container xs={12} spacing={2} style={{ paddingBottom: '20px' }}>
                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <MaterialTextFieldComponent
                                                        placeHolder={"نام"}
                                                        label={"نام"}
                                                        required={true}
                                                        name={"userFirstname"}
                                                        id={"userFirstname"}
                                                        // autoFocus={true}
                                                        value={values.userFirstname}
                                                        onChange={handleChange}
                                                        helperText={
                                                            touched.userFirstname
                                                                ? errors.userFirstname
                                                                : ""
                                                        }
                                                        error={
                                                            touched.userFirstname &&
                                                            Boolean(errors.userFirstname)
                                                        }
                                                        onBlur={handleBlur}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <MaterialTextFieldComponent
                                                        placeHolder={"نام خانوادگی"}
                                                        label={"نام خانوادگی"}
                                                        required={true}
                                                        name={"userLastname"}
                                                        id={"userLastname"}
                                                        value={values.userLastname}
                                                        onChange={handleChange}
                                                        helperText={
                                                            touched.userLastname
                                                                ? errors.userLastname
                                                                : ""
                                                        }
                                                        error={
                                                            touched.userLastname &&
                                                            Boolean(errors.userLastname)
                                                        }
                                                        onBlur={handleBlur}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container xs={12} spacing={2} style={{ paddingBottom: '20px' }}>
                                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                                    <MaterialTextFieldComponent
                                                        placeHolder={"شماره موبایل"}
                                                        label={"شماره موبایل"}
                                                        required={true}
                                                        name={"mobileNo"}
                                                        id={"mobileNo"}
                                                        inputProps={{ maxLength: 11 }}
                                                        value={values.mobileNo}
                                                        onChange={handleChange}
                                                        helperText={
                                                            touched.mobileNo ? errors.mobileNo : ""
                                                        }
                                                        error={
                                                            touched.mobileNo && Boolean(errors.mobileNo)
                                                        }
                                                        onBlur={handleBlur}
                                                        onKeyDown={(event) => {
                                                            if (event.code === "Space") {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item xs={6} sm={6} md={6} lg={6} xl={6}
                                                    className="supp-users-search"
                                                >
                                                    <AutoCompleteSearch
                                                        label={"استان و شهر محل فعالیت"}
                                                        name={`city`}
                                                        id={`city`}
                                                        value={cityIds}
                                                        options={cities}
                                                        onChange={changeCityIds}
                                                        responseValue={city}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container xs={12} style={{ paddingBottom: '20px' }}>
                                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                                    <SideSwich
                                                        Label={"سطح دسترسی"}
                                                        checked={values.isActive || false}
                                                        onChange={(checked: boolean = false) => {
                                                            values.isActive = checked;
                                                        }}
                                                        onlabel={"کامل"}
                                                        offlabel={"محدود"}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container xs={12}>
                                                <Grid item xs={6}></Grid>
                                                <Grid item xs={6}>
                                                    <Grid
                                                        container
                                                        justifyContent={"center"}
                                                        alignItems={"center"}
                                                        gap={1}
                                                        marginBottom={"8px"}
                                                    >
                                                        <Grid item xs={5} width={"100%"}>
                                                            <Button
                                                                fullWidth
                                                                type="submit"
                                                                variant="contained"
                                                                sx={{ borderRadius: "5px !important" }}
                                                                disabled={
                                                                    !values.userFirstname ||
                                                                    !values.userLastname ||
                                                                    !values.mobileNo ||
                                                                    !cityIds
                                                                }
                                                                className={
                                                                    !values.userFirstname ||
                                                                        !values.userLastname ||
                                                                        !values.mobileNo ||
                                                                        !cityIds
                                                                        ? "btnForm disabledBtn"
                                                                        : "btnForm SuccessDefault"
                                                                }
                                                            >
                                                                افزودن
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={5} width={"100%"}>
                                                            <Button
                                                                fullWidth
                                                                variant="contained"
                                                                style={{
                                                                    fontSize: "1rem",
                                                                    color: "#fff",
                                                                    height: "40px",
                                                                    background: "#607D8B",
                                                                }}
                                                                sx={{ borderRadius: "5px !important" }}
                                                                onClick={handleClose}
                                                            >
                                                                انصراف
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </Grid>
                </>
            </Modal>
        </div>
    );
}
